import { ButtonProps as MuiButtonProps, CircularProgress } from "@mui/material";
import { useFormikContext } from "formik";
import { ReactElement, ReactNode } from "react";

import TooltipButton from "../TooltipButton";

export type ButtonProps = MuiButtonProps & {
  disabled?: boolean;
  submitText?: string | ReactNode;
  loadingText?: string | ReactNode;
  tooltipText?: string | ReactNode;
};

export default function SubmitButton({
  isSubmitting = false,
  disabled = false,
  submitText = "Submit",
  loadingText = submitText,
  tooltipText,
  ...props
}: ButtonProps & { isSubmitting?: boolean }): ReactElement {
  return (
    <TooltipButton
      tooltipText={tooltipText}
      type="submit"
      variant="contained"
      color="primary"
      disabled={isSubmitting || disabled}
      {...props}
    >
      {isSubmitting && (
        <CircularProgress size={20} sx={{ marginRight: "12px" }} />
      )}
      {isSubmitting ? loadingText : submitText}
    </TooltipButton>
  );
}

export function FormikSubmitButton(props: ButtonProps): ReactElement {
  const formik = useFormikContext();

  return (
    <SubmitButton
      {...props}
      isSubmitting={formik.isSubmitting}
      disabled={props.disabled || formik.isSubmitting}
    />
  );
}
